module.exports = __webpack_public_path__ + "img/linggekj_name@3x.bdbf3613.png";